// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage } from "react-intl";

export const LensesBreadcrumb = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.lensesBreadcrumb"
        description="Lenses breadcrumb."
        defaultMessage="Lenses"
    />
);
LensesBreadcrumb.displayName = "LensesBreadcrumb";

export const LensBreadcrumb = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.lensBreadcrumb"
        description="Lens breadcrumb."
        defaultMessage="Lens"
    />
);
LensBreadcrumb.displayName = "LensBreadcrumb";

export const AdAccountTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.adAccountTitle"
        description="Ad account title."
        defaultMessage="Ad Account"
    />
);
AdAccountTitle.displayName = "AdAccountTitle";

export const PublicProfileTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.publicProfileTitle"
        description="Public profile title."
        defaultMessage="Public Profile"
    />
);
PublicProfileTitle.displayName = "PublicProfileTitle";

export const OwnProfileTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.ownProfileTitle"
        description="Own profile title."
        defaultMessage="Your Profile"
    />
);
OwnProfileTitle.displayName = "OwnProfileTitle";

export const UserProfileTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.userProfileTitle"
        description="User profile title."
        defaultMessage="Profile"
    />
);
UserProfileTitle.displayName = "UserProfileTitle";

export const LensDestinationTooltipTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.lensDestinationTooltipTitle"
        description="Lens destination tooltip title."
        defaultMessage="Status"
    />
);
LensDestinationTooltipTitle.displayName = "LensDestinationTooltipTitle";

export const PublishModalTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.publishModalTitle"
        description="Publish modal title."
        defaultMessage="Publishing Lens"
    />
);
PublishModalTitle.displayName = "PublishModalTitle";

export const UpdateModalTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.updateModalTitle"
        description="Update modal title."
        defaultMessage="Updating Lens"
    />
);
UpdateModalTitle.displayName = "UpdateModalTitle";

export const PublicationWarning = (props: { username: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.publicationWarning"
        description="Publication warning."
        defaultMessage="Lens will be published to {username}'s Profile"
        values={props}
    />
);
PublicationWarning.displayName = "PublicationWarning";

export const UpdatingWarning = (props: { lensName: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.updatingWarning"
        description="Updating warning."
        defaultMessage="Updating visibility of {lensName}"
        values={props}
    />
);
UpdatingWarning.displayName = "UpdatingWarning";

export const UpdatingWarningText = (props: { lensName: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.updatingWarningText"
        description="Updating warning text."
        defaultMessage="Updating visibility of {lensName} will be reflected on existing Lens distributions."
        values={props}
    />
);
UpdatingWarningText.displayName = "UpdatingWarningText";

export const PublicationWarningText = (props: { username: ReactNode; learnMore: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.publicationWarningText"
        description="Publication warning text."
        defaultMessage="Lens will be permanently published to {username}’s profile. This cannot be undone. {learnMore} about publishing to other accounts."
        values={props}
    />
);
PublicationWarningText.displayName = "PublicationWarningText";

export const LearnMoreText = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.learnMoreText"
        description="Learn more text."
        defaultMessage="Learn more"
    />
);
LearnMoreText.displayName = "LearnMoreText";

export const VisibilityTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.visibilityTitle"
        description="Visibility title."
        defaultMessage="Visibility"
    />
);
VisibilityTitle.displayName = "VisibilityTitle";

export const DistributionRestictionsTooltipOpeningMessage = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.distributionRestictionsTooltipOpeningMessage"
        description="Distribution restictions tooltip opening message."
        defaultMessage="Your Lens has been approved with limited reach."
    />
);
DistributionRestictionsTooltipOpeningMessage.displayName = "DistributionRestictionsTooltipOpeningMessage";

export const DistributionRestictionsTooltipMessage = (props: { learnMore: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.distributionRestictionsTooltipMessage"
        description="Distribution restictions tooltip message."
        defaultMessage="{learnMore} about potential reasons and how to increase your Lens reach."
        values={props}
    />
);
DistributionRestictionsTooltipMessage.displayName = "DistributionRestictionsTooltipMessage";

export const LearnMoreDistributionRestrictions = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.learnMoreDistributionRestrictions"
        description="Learn more distribution restrictions."
        defaultMessage="Learn more"
    />
);
LearnMoreDistributionRestrictions.displayName = "LearnMoreDistributionRestrictions";

export const DistributionRestrictionsHeader = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.distributionRestrictionsHeader"
        description="Distribution restrictions header."
        defaultMessage="Limited Reach"
    />
);
DistributionRestrictionsHeader.displayName = "DistributionRestrictionsHeader";

export const DistributionRestrictionsGeneralMessage = (props: { docsLink: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.distributionRestrictionsGeneralMessage"
        description="Distribution restrictions general message."
        defaultMessage="Your Lens has been approved but may not be promoted to all Snapchatters. Please review our {docsLink} and update your Lens so that it’s eligible to reach a larger audience."
        values={props}
    />
);
DistributionRestrictionsGeneralMessage.displayName = "DistributionRestrictionsGeneralMessage";

export const DistributionRestrictionsDocsLinkText = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.distributionRestrictionsDocsLinkText"
        description="Distribution restrictions docs link text."
        defaultMessage="Lens content requirements"
    />
);
DistributionRestrictionsDocsLinkText.displayName = "DistributionRestrictionsDocsLinkText";

export const DistributionRestrictionsOpeningMessage = (props: { lensName: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.distributionRestrictionsOpeningMessage"
        description="Distribution restrictions opening message."
        defaultMessage="Your Lens, {lensName} has been approved but may not be promoted to all Snapchatters due to the following reason(s):"
        values={props}
    />
);
DistributionRestrictionsOpeningMessage.displayName = "DistributionRestrictionsOpeningMessage";

export const DistributionRestrictionsClosingMessage = (props: { docsLink: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.distributionRestrictionsClosingMessage"
        description="Distribution restrictions closing message."
        defaultMessage="Your Lens has been approved but may not be promoted to all Snapchatters. Please review our {docsLink} and update your Lens to so that it’s eligible to reach a larger audience."
        values={props}
    />
);
DistributionRestrictionsClosingMessage.displayName = "DistributionRestrictionsClosingMessage";

export const GameLensCriteriaModalTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.gameLensCriteriaModalTitle"
        description="Game lens criteria modal title."
        defaultMessage="Game Lens"
    />
);
GameLensCriteriaModalTitle.displayName = "GameLensCriteriaModalTitle";

export const GameLensCriteriaModalSubtitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.gameLensCriteriaModalSubtitle"
        description="Game lens criteria modal subtitle."
        defaultMessage="To be considered a Game Lens, your Lens must follow the criteria below."
    />
);
GameLensCriteriaModalSubtitle.displayName = "GameLensCriteriaModalSubtitle";

export const GameLensCriteriaUserInputLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.gameLensCriteriaUserInputLabel"
        description="Game lens criteria user input label."
        defaultMessage="User Input"
    />
);
GameLensCriteriaUserInputLabel.displayName = "GameLensCriteriaUserInputLabel";

export const GameLensCriteriaUserInputDescription = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.gameLensCriteriaUserInputDescription"
        description="Game lens criteria user input description."
        defaultMessage="Players take actions in the game that influence the next event, as opposed to automation"
    />
);
GameLensCriteriaUserInputDescription.displayName = "GameLensCriteriaUserInputDescription";

export const GameLensCriteriaGoalChallengeObjectiveLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.gameLensCriteriaGoalChallengeObjectiveLabel"
        description="Game lens criteria goal challenge objective label."
        defaultMessage="Goal, Challenge, or Objective"
    />
);
GameLensCriteriaGoalChallengeObjectiveLabel.displayName = "GameLensCriteriaGoalChallengeObjectiveLabel";

export const GameLensCriteriaGoalChallengeObjectiveDescription = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.gameLensCriteriaGoalChallengeObjectiveDescription"
        description="Game lens criteria goal challenge objective description."
        defaultMessage="Players have a clear purpose to achieve when playing the game that leads towards a score or victory"
    />
);
GameLensCriteriaGoalChallengeObjectiveDescription.displayName = "GameLensCriteriaGoalChallengeObjectiveDescription";

export const GameLensCriteriaSystemFeedbackLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.gameLensCriteriaSystemFeedbackLabel"
        description="Game lens criteria system feedback label."
        defaultMessage="System Feedback"
    />
);
GameLensCriteriaSystemFeedbackLabel.displayName = "GameLensCriteriaSystemFeedbackLabel";

export const GameLensCriteriaSystemFeedbackDescription = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.gameLensCriteriaSystemFeedbackDescription"
        description="Game lens criteria system feedback description."
        defaultMessage="The game responds visibly or audibly to a player’s actions"
    />
);
GameLensCriteriaSystemFeedbackDescription.displayName = "GameLensCriteriaSystemFeedbackDescription";

export const GameLensCriteriaGameplayLoopLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.gameLensCriteriaGameplayLoopLabel"
        description="Game lens criteria gameplay loop label."
        defaultMessage="Gameplay Loop"
    />
);
GameLensCriteriaGameplayLoopLabel.displayName = "GameLensCriteriaGameplayLoopLabel";

export const GameLensCriteriaGameplayLoopDescription = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.gameLensCriteriaGameplayLoopDescription"
        description="Game lens criteria gameplay loop description."
        defaultMessage="The game has a loop in which a player’s actions result in system feedback, which includes progressing or restarting the intended experience for the game."
    />
);
GameLensCriteriaGameplayLoopDescription.displayName = "GameLensCriteriaGameplayLoopDescription";

export const SpectaclesOnlyVisibilityNotice = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.spectaclesOnlyVisibilityNotice"
        description="Spectacles only visibility notice."
        defaultMessage="Spectacles Lenses do not currently support visibility options."
    />
);
SpectaclesOnlyVisibilityNotice.displayName = "SpectaclesOnlyVisibilityNotice";

export const SpectaclesOnlyVisibilityOptionsNotice = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.spectaclesOnlyVisibilityOptionsNotice"
        description="Spectacles only visibility options notice."
        defaultMessage="This option is disabled for Spectacles Lens."
    />
);
SpectaclesOnlyVisibilityOptionsNotice.displayName = "SpectaclesOnlyVisibilityOptionsNotice";

export const LensPlusOnlyVisibilityNotice = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.lensPlusOnlyVisibilityNotice"
        description="Lens plus only visibility notice."
        defaultMessage="Lens+ Payouts Lenses requires public visibility."
    />
);
LensPlusOnlyVisibilityNotice.displayName = "LensPlusOnlyVisibilityNotice";

export const LensPlusOnlyVisibilityOptionsNotice = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.lensPlusOnlyVisibilityOptionsNotice"
        description="Lens plus only visibility options notice."
        defaultMessage="This option is disabled for Lens+ Payouts Lenses."
    />
);
LensPlusOnlyVisibilityOptionsNotice.displayName = "LensPlusOnlyVisibilityOptionsNotice";

export const Unsaved = (): ReactElement => (
    <FormattedMessage id="apps.lens.components.shared.unsaved" description="Unsaved." defaultMessage="Unsaved" />
);
Unsaved.displayName = "Unsaved";

export const AiClipsAlertTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.aiClipsAlertTitle"
        description="Ai clips alert title."
        defaultMessage="AI Clip Lens"
    />
);
AiClipsAlertTitle.displayName = "AiClipsAlertTitle";

export const AiClipsAlertMessage = (props: { learnMore: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.aiClipsAlertMessage"
        description="Ai clips alert message."
        defaultMessage="May be made Exclusive to Lens+ subscribers. {learnMore}."
        values={props}
    />
);
AiClipsAlertMessage.displayName = "AiClipsAlertMessage";

export const Cancel = (): ReactElement => (
    <FormattedMessage id="apps.lens.components.shared.cancel" description="Cancel." defaultMessage="Cancel" />
);
Cancel.displayName = "Cancel";

export const ErrorTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.errorTitle"
        description="Error title."
        defaultMessage="Unable to publish"
    />
);
ErrorTitle.displayName = "ErrorTitle";
